<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container create-user-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>{{ editMode ? 'Edit User' : 'Create New User' }}</h2>
    </div>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="userForm" autocomplete="off">
      <!-- 1. First Name & 2. Last Name -->
      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First Name <span class="required">*</span></label>
          <input
            id="firstName"
            type="text"
            pInputText
            placeholder="Enter First name"
            formControlName="firstName"
            (keypress)="preventNumbers($event)"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['firstName'].invalid }"
          />
        </div>
        <div class="form-group">
          <label for="lastName">Last Name <span class="required">*</span></label>
          <input
            id="lastName"
            type="text"
            pInputText
            placeholder="Enter Last name"
            formControlName="lastName"
            (keypress)="preventNumbers($event)"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['lastName'].invalid }"
          />
        </div>
      </div>

      <!-- 3. Email ID & 4. Role Type -->
      <div class="form-row">
        <div class="form-group">
          <label for="emailId">Email ID <span class="required">*</span></label>
          <input
            id="emailId"
            type="email"
            pInputText
            placeholder="Enter Email ID"
            formControlName="email"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['email'].invalid }"
          />
        </div>
        <div class="form-group">
          <label for="roleType">Role Type <span class="required">*</span></label>
          <p-dropdown
            [options]="roles"
            optionLabel="name"
            [filter]="true"
            formControlName="roleType"
            placeholder="Select Role Type"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['roleType'].invalid }"
          ></p-dropdown>
        </div>
      </div>

      <!-- Status and End Date for edit mode (unchanged design) -->
      <div class="form-row" *ngIf="editMode">
        <div class="form-group">
          <label for="status">Status <span class="required">*</span></label>
          <p-dropdown
            id="status"
            formControlName="status"
            [options]="[{label: 'Active', value: 'Active'}, {label: 'Inactive', value: 'Inactive'}]"
            placeholder="Select Status"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [panelStyle]="{ minWidth: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['status'].invalid }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="endDate">End Date</label>
          <div class="date-with-clear" style="display:flex; align-items:center; gap:0.5rem;">
            <p-calendar
              id="endDate"
              formControlName="endDate"
              [showIcon]="true"
              dateFormat="yy-mm-dd"
              placeholder="Select End Date"
              [appendTo]="'body'"
              [minDate]="tomorrow"
              [readonlyInput]="false"
              (onSelect)="validateEndDate($event)"
              [showButtonBar]="true"
              [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['endDate'].invalid }"
              [style.width]="userForm.controls['endDate'].value ? 'calc(100% - 44px)' : '100%'"
            ></p-calendar>
            <button type="button" class="p-button p-button-text p-button-plain" aria-label="Clear date" (click)="clearEndDate()" *ngIf="userForm.controls['endDate'].value" [disabled]="isSubmitting" style="padding:0.35rem; border-radius:50%; height:2.2rem; width:2.2rem; display:inline-flex; align-items:center; justify-content:center;">
              <i class="pi pi-times" style="font-size:1rem;"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- CREATE MODE: User Country + End Date on same row -->
      <div class="form-row" *ngIf="!editMode">
        <div class="form-group">
          <label for="userCountry">User Country <span class="required">*</span></label>
          <p-dropdown
            [options]="countries"
            optionLabel="name"
            [filter]="true"
            formControlName="userCountry"
            placeholder="Select Country"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['userCountry'].invalid }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="endDate">End Date</label>
          <div class="date-with-clear" style="display:flex; align-items:center; gap:0.5rem;">
            <p-calendar
              id="endDate"
              formControlName="endDate"
              [showIcon]="true"
              dateFormat="yy-mm-dd"
              placeholder="Select End Date"
              [appendTo]="'body'"
              [minDate]="tomorrow"
              [readonlyInput]="false"
              (onSelect)="validateEndDate($event)"
              [showButtonBar]="true"
              [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['endDate'].invalid }"
              [style.width]="userForm.controls['endDate'].value ? 'calc(100% - 44px)' : '100%'"
            ></p-calendar>
            <button type="button" class="p-button p-button-text p-button-plain" aria-label="Clear date" (click)="clearEndDate()" *ngIf="userForm.controls['endDate'].value" [disabled]="isSubmitting" style="padding:0.35rem; border-radius:50%; height:2.2rem; width:2.2rem; display:inline-flex; align-items:center; justify-content:center;">
              <i class="pi pi-times" style="font-size:1rem;"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- CREATE MODE: Responsible Region + Responsible Country on next row -->
      <div class="form-row" *ngIf="!editMode">
        <div class="form-group">
          <label for="responsibleRegion">User Responsible Region <span class="required">*</span></label>
          <p-dropdown
            id="responsibleRegion"
            formControlName="responsibleRegion"
            [options]="regions"
            optionLabel="name"
            placeholder="Select a Responsible Region"
            [filter]="true"
            [showClear]="true"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['responsibleRegion'].invalid }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="userResponsibleCountry">User Responsible Country <span class="required">*</span></label>
          <span
            [pTooltip]="!userForm.controls['responsibleRegion'].value ? 'Please select a User Responsible Region first.' : ''"
            tooltipPosition="top"
          >
            <p-multiSelect
              id="userResponsibleCountry"
              [options]="filteredResponsibleCountries"
              formControlName="responsibleCountry"
              optionLabel="name"
              placeholder="Select Countries"
              display="comma"
              [filter]="true"
              [showClear]="true"
              [maxSelectedLabels]="2"
              selectedItemsLabel="'{0} selected'"
              [appendTo]="'body'"
              [panelStyle]="{ maxHeight: '320px' }"
              [disabled]="!userForm.controls['responsibleRegion'].value"
              [style]="{ width: '100%' }"
              [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['responsibleCountry'].invalid }"
            ></p-multiSelect>
          </span>
        </div>
      </div>

      <!-- EDIT MODE: keep original User Country + Responsible Region row -->
      <div class="form-row" *ngIf="editMode">
        <div class="form-group">
          <label for="userCountry">User Country <span class="required">*</span></label>
          <p-dropdown
            [options]="countries"
            optionLabel="name"
            [filter]="true"
            formControlName="userCountry"
            placeholder="Select Country"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['userCountry'].invalid }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="responsibleRegion">User Responsible Region <span class="required">*</span></label>
          <p-dropdown
            id="responsibleRegion"
            formControlName="responsibleRegion"
            [options]="regions"
            optionLabel="name"
            placeholder="Select a Responsible Region"
            [filter]="true"
            [showClear]="true"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['responsibleRegion'].invalid }"
          ></p-dropdown>
        </div>
      </div>

      <!-- EDIT MODE: Responsible Country + Company Name (original) -->
      <div class="form-row" *ngIf="editMode">
        <div class="form-group">
          <label for="userResponsibleCountry">User Responsible Country <span class="required">*</span></label>
          <span
            [pTooltip]="!userForm.controls['responsibleRegion'].value ? 'Please select a User Responsible Region first.' : ''"
            tooltipPosition="top"
          >
            <p-multiSelect
              id="userResponsibleCountry"
              [options]="filteredResponsibleCountries"
              formControlName="responsibleCountry"
              optionLabel="name"
              placeholder="Select Countries"
              display="comma"
              [filter]="true"
              [showClear]="true"
              [maxSelectedLabels]="2"
              selectedItemsLabel="'{0} selected'"
              [appendTo]="'body'"
              [panelStyle]="{ maxHeight: '320px' }"
              [disabled]="!userForm.controls['responsibleRegion'].value"
              [style]="{ width: '100%' }"
              [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['responsibleCountry'].invalid }"
            ></p-multiSelect>
          </span>
        </div>
        <div class="form-group">
          <label for="companyName">Company Name <span class="required">*</span></label>
          <input
            id="companyName"
            type="text"
            pInputText
            placeholder="Enter the company name"
            formControlName="companyName"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['companyName'].invalid }"
          />
        </div>
      </div>

      <!-- CREATE MODE: Company Name on its own row (use two-column layout so it's not full width) -->
      <div class="form-row" *ngIf="!editMode">
        <div class="form-group">
          <label for="companyName">Company Name <span class="required">*</span></label>
          <input
            id="companyName"
            type="text"
            pInputText
            placeholder="Enter the company name"
            formControlName="companyName"
            [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && userForm.controls['companyName'].invalid }"
          />
        </div>
        <div class="form-group"><!-- spacer column to keep two-column layout --></div>
      </div>

      <!-- Certificate section: create vs edit -->
      <div class="form-row">
        <div class="form-group full-width">
          <label for="certificateFile">
            {{ editMode ? '' : 'Upload Certificate' }}
            <span class="required" *ngIf="!editMode">*</span>
          </label>

          <!-- Create mode: existing upload UI -->
          <ng-container *ngIf="!editMode; else viewCertOnly">
            <div class="certificate-upload-container">
              <input id="certificateFile" type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" 
                    accept=".pdf,.doc,.png" />

              <button type="button" class="p-button p-button-primary upload-button" 
                      (click)="fileInput.click()" [disabled]="isSubmitting">
                <i class="pi pi-upload"></i> Upload Certificate
              </button>

              <div class="uploaded-files" *ngIf="uploadedFile">
                <div class="file-item">
                  <div class="file-info">
                    <i class="pi pi-file"></i>
                    <span class="file-name">{{ uploadedFile.name }}</span>
                    
                    <span class="file-status" *ngIf="uploadedFile.uploading">
                      <i class="pi pi-spin pi-spinner"></i> Uploading...
                    </span>
                    <span class="file-status success" *ngIf="uploadedFile.uploaded">
                      <i class="pi pi-check-circle"></i> Uploaded
                    </span>
                    <span class="file-status error" *ngIf="uploadedFile.error">
                      <i class="pi pi-exclamation-triangle"></i> {{ uploadedFile.error }}
                    </span>
                  </div>
                  
                  <button type="button" class="delete-file-button" 
                          (click)="confirmDeleteFile()" 
                          [disabled]="uploadedFile.uploading || isSubmitting">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </div>
              
              <!-- Show error message if certificate is required but not uploaded -->
              <small class="p-error" *ngIf="formSubmitted && !uploadedFile">
                Certificate upload is required
              </small>
            </div>
          </ng-container>

          <!-- Edit mode: only View Certificate button -->
          <ng-template #viewCertOnly>

            <button type="button"
                    *ngIf="uploadedFile?.url || userData?.certificate_url || userData?.certificate_info?.url"
                    pButton
                    label="View Certificate"
                   class="p-button p-button-primary upload-button"
                    (click)="openCertificateViewer()">
            </button>
          </ng-template>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary"
        (click)="close()"
        [disabled]="isSubmitting"
      ></button>
     <!-- In the footer template -->
      <button
        pButton
        type="button"
        class="p-button-warning"
        (click)="onSubmit()"
  [disabled]="!userForm.valid || (!editMode && !uploadedFile)"
      >
        <i class="pi pi-spin pi-spinner" *ngIf="isSubmitting"></i>
          Submit
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog 
  [style]="{width: '30vw'}" 
  acceptButtonStyleClass="p-button-yellow" 
  rejectButtonStyleClass="p-button-secondary">
</p-confirmDialog>